<script setup>
// Astra DS · TooltipCabecera — `Tooltip 2396:28557`.
//
// Nombra lo que un icono de la cabecera ya es: hoy, solo los dos accesos a las
// apps (`TiendaIcono`). Entrega `docs/entregas/2026-10-06-donar.md`.
//
// Cuelga del filete inferior de la cabecera, pegado a él y **centrado bajo su
// celda**; el de la última celda se alinea a su canto derecho para no salirse.
// `bg/elevated`, `border/strong` a izquierda, derecha y abajo —sin canto
// superior, porque cuelga del filete, como `AccountMenu`—, radio 0, sin sombra
// ni punta. Aparece y se va sin animación ni retardo. Va por encima de la
// página, no la empuja.
//
// Se pinta fuera del `<header>` y en posición fija: la cabecera lleva
// `overflow: hidden` y dentro quedaría recortado. `SiteHeader` le pasa la celda
// y aquí se mide.
import { computed } from "vue";

const props = defineProps({
  kicker: { type: String, required: true },
  nombre: { type: String, required: true },
  // La celda que lo saca, para colocarlo bajo ella.
  celda: { type: Object, required: true },
  // Dónde termina la cabecera, el filete del que cuelga.
  techo: { type: Number, required: true },
  // `derecha` para la última celda: se alinea a su canto derecho.
  alinear: { type: String, default: "centro" },
});

const estilo = computed(() => {
  const r = props.celda.getBoundingClientRect();
  if (props.alinear === "derecha") {
    return { top: `${props.techo}px`, right: `${window.innerWidth - r.right}px` };
  }
  return {
    top: `${props.techo}px`,
    left: `${r.left + r.width / 2}px`,
    transform: "translateX(-50%)",
  };
});
</script>

<template>
  <div class="tooltip-cabecera" role="tooltip" :style="estilo">
    <span class="tooltip-cabecera__kicker">{{ kicker }}</span>
    <span class="tooltip-cabecera__nombre">{{ nombre }}</span>
  </div>
</template>

<style scoped lang="scss">
@use "@/assets/scss/type" as t;

.tooltip-cabecera {
  position: fixed;
  z-index: 81;
  display: flex;
  flex-direction: column;
  gap: 1px;
  // 7 · 10 · 8 · 10, del nodo.
  padding: 7px 10px 8px;
  border: 1px solid var(--color-border-strong);
  border-top: 0;
  background: var(--color-bg-elevated);
  white-space: nowrap;
  pointer-events: none;
}

.tooltip-cabecera__kicker {
  @include t.mono-tab;
  color: var(--color-text-secondary);
  text-transform: uppercase;
}

.tooltip-cabecera__nombre {
  @include t.mono-label;
  color: var(--color-text-primary);
  text-transform: uppercase;
}
</style>
